var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49902 5.01009C2.49902 4.08962 3.24522 3.34342 4.16569 3.34342H15.8324C16.7528 3.34342 17.499 4.08962 17.499 5.01009V15.8434C17.499 16.7639 16.7528 17.5101 15.8324 17.5101H4.16569C3.24522 17.5101 2.49902 16.7639 2.49902 15.8434V5.01009ZM15.8324 5.01009H4.16569V15.8434H15.8324V5.01009Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49902 1.67676C7.95926 1.67676 8.33236 2.04985 8.33236 2.51009L8.33236 5.84342C8.33236 6.30366 7.95926 6.67676 7.49902 6.67676C7.03879 6.67676 6.66569 6.30366 6.66569 5.84342L6.66569 2.51009C6.66569 2.04985 7.03879 1.67676 7.49902 1.67676Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48682 8.34342C2.48682 7.88319 2.85991 7.51009 3.32015 7.51009H16.6331C17.0934 7.51009 17.4665 7.88319 17.4665 8.34342C17.4665 8.80366 17.0934 9.17676 16.6331 9.17676H3.32015C2.85991 9.17676 2.48682 8.80366 2.48682 8.34342Z",
    fill: "#21272F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.499 1.67676C12.9593 1.67676 13.3324 2.04985 13.3324 2.51009L13.3324 5.84342C13.3324 6.30366 12.9593 6.67676 12.499 6.67676C12.0388 6.67676 11.6657 6.30366 11.6657 5.84342L11.6657 2.51009C11.6657 2.04985 12.0388 1.67676 12.499 1.67676Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDate);
export default __webpack_public_path__ + "static/media/menuDate.ede1c21b9d3ed9616ef120a34f9df69a.svg";
export { ForwardRef as ReactComponent };